import $ from 'jquery';

export const init = ($target) => {
	const $jsPriceSticky = $('.js-price-sticky');
	if (!$jsPriceSticky) {
		return;
	}

	const $jsTextSwitchable = $jsPriceSticky.find('.js-sticky-text-switchable'),
		$jsSubTxt = $jsPriceSticky.find('.js-sticky-sub-text'),
		$jsBtn = $jsPriceSticky.find('.js-sticky-btn'),
		$jsSwitch = $jsPriceSticky.find('.js-sticky-switch'),
		$jsHeroSticky = $('.js-hero-sticky'),
		$isGreenInput = $jsPriceSticky.find('input[name=isgreen]'),
		apiUrl = $jsPriceSticky.data('save-is-green-url'),
		productId = parseInt($jsPriceSticky.data('product-id')),
		consumerType = $jsPriceSticky.data('consumer-type'),
		commodityType = $jsPriceSticky.data('commodity-type');

	$jsSwitch.on('click', function (e, preventSave) {
		$jsSubTxt.toggleClass('price-sticky__sub-text--turquoise');
		$jsBtn.toggleClass('btn--turquoise');
		$jsHeroSticky.toggleClass('is-turquoise');
		$jsTextSwitchable.each(function () {
			switchText($(this));
		});

		if (preventSave) {
			return;
		}

		saveIsGreen();
	});

	function switchText($switchableText) {
		const currentText = $switchableText.text(),
			switchText = $switchableText.data('switch-text');

		$switchableText.text(switchText);
		$switchableText.data('switch-text', currentText);
	}

	function saveIsGreen() {
		const selectedProduct = {
			productId: productId,
			consumerType: consumerType,
			commodityType: commodityType,
			isGreen: $isGreenInput.is(':checked'),
		};
		const searchParams = new URLSearchParams(selectedProduct);

		return $.ajax({
			type: 'POST',
			url: apiUrl + '?' + searchParams.toString(),
		});
	}

	$target.ready(() => {
		const initGreen = $jsPriceSticky.data('is-green')?.toString().toLowerCase();
		if (initGreen == 'true') {
			$jsSwitch.trigger('click', true);
		}
	});
};
